import React, { useCallback, useEffect, useState } from 'react';
import { Box, Grid, Button } from '@mui/material';
import AxiosInstance from '../../../server/AxioInstance';
import TableComponent from '../../common/table/Table';
import ApproveBotton from '../../common/approveBotton/ApproveBotton';

const columns = [
  { id: 'description', label: 'Setor', align: 'left' },
  { id: 'registration_date', label: 'Data', align: 'center' },
  { id: 'ativo', label: 'Ativo', align: 'center' },
  { id: 'acao', label: 'Ação', align: 'center' },
];

const SubSectorConsultLayout = ({ handleChangeComponent }) => {
  const [rows, setRows] = useState([]);

  const handleConsultSector = useCallback(async () => {
    const result = await AxiosInstance.get('/sector/consult-sub-sectors');
    const temp = result?.data?.rows?.map((item) => ({
      ...item,
      ativo: item.active ? 'ATIVADO' : 'DESATIVADO',
      acao: (
        <ApproveBotton
          title="Editar Sub-Setor"
          url="/sector/active-sub-sectors"
          item={item}
          handleChangeComponent={handleChangeComponent}
          handleCosnult={handleConsultSector}
        />
      ),
    }));
    setRows(temp);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    handleConsultSector();
  }, [handleConsultSector]);

  return (
    <Box m={1}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} xl={4}>
          <Button
            variant="contained"
            fullWidth
            onClick={() => handleChangeComponent('Criar Sub-Setores', 'create')}
          >
            cadastrar
          </Button>
        </Grid>
        <Grid item xs={12} md={12} xl={12}>
          <TableComponent columns={columns} rows={rows} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SubSectorConsultLayout;
